import React, { ReactElement } from 'react'
import { MismatchTubeResult } from './types/models'

type MismatchModalProps = {
  fullPath: string;
  mismatchTubeClampResults: MismatchTubeResult[];
  proceedToCheckout: (crossSells, fullPath) => void;
  setShowBasketModal: (bool: boolean) => void;
  sizesAndDiameters: string;
}

const MismatchModal = ({ mismatchTubeClampResults, fullPath, proceedToCheckout, setShowBasketModal, sizesAndDiameters }: MismatchModalProps): ReactElement => (
  <div className="mismatchModal-container">
    <div className="mismatchModal-content">
      <div>
        <div className="mismatchModal-content-text">
          <h1 className="mismatchModal-header">
            Just a Quick Heads-up! 👋
          </h1>
          <p className="mismatchModal-paragraph">
            We’ve noticed that some of the tube or clamp fittings in your basket are a different size to the others — your basket contains a mix of {sizesAndDiameters} parts. This might be exactly what you need, but it can also be a common mix-up.
          </p>
          <p className="mismatchModal-paragraph">
            Below is what looks a little different to us. Take a quick moment to double-check before you head to checkout — just to be sure everything is going to fit together nicely!
          </p>
        </div>
        <div className="mismatchModal-productListings">
          {mismatchTubeClampResults.map((result) => (
            <div key={result.name} className="mismatchModal-productListing">
              <div className="mismatchModal-productListing-image"><img src={result.thumbnail_2x} alt="" width="78" height="72"></img></div>
              <div className="mismatchModal-productListing-nameContainer">
                <div className="mismatchModal-productListing-name">
                  {result.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="mismatchModal-acceptDeclineContainer">
        <button onClick={() => proceedToCheckout([], fullPath)} className="basket-tube-clamp-notice-confirm">Everything’s good - continue</button>
        <button onClick={() => setShowBasketModal(false)} className="basket-tube-clamp-notice-decline">Go back to basket</button>
      </div>
    </div>
  </div>
)

export default MismatchModal
